import { GoldMinePlanSheet } from '@/features/gold-mine';
import { gmsRecommendedAmount } from '@/features/gold-mine/utils/gmsPlan.utils';
import { cn } from '@/shared/utils/cn';
import { usePdpBuyActions } from '../hooks/usePdpBuyActions';

interface PdpBuyActionsProps {
  variant: 'fixed' | 'inline';
  discountedPrice: number | null;
  gmsFirstInstallmentDiscountEnabled: boolean;
  gmsFirstInstallmentDiscountPercentage: number;
  onBuyNow?: () => void;
  onBuyNowClick?: () => void;
  onGmsPlanOpen?: (monthlyAmount: number) => void;
  onGmsSubscribeClick?: () => void;
  onGmsTncClick?: () => void;
}

export function PdpBuyActions({
  variant,
  discountedPrice,
  gmsFirstInstallmentDiscountEnabled,
  gmsFirstInstallmentDiscountPercentage,
  onBuyNow,
  onBuyNowClick,
  onGmsPlanOpen,
  onGmsSubscribeClick,
  onGmsTncClick,
}: PdpBuyActionsProps) {
  const { isGmsSheetOpen, handleOpenGmsSheet, handleBuyNow, handleCloseGmsSheet } =
    usePdpBuyActions({ onBuyNow, onBuyNowClick, onGmsPlanOpen });

  const gmsPrice = discountedPrice ?? 0;
  const gmsMonthlyAmount = gmsRecommendedAmount(gmsPrice);

  const buyNowButton = (
    <button
      type="button"
      onClick={handleBuyNow}
      className={cn(
        'flex items-center justify-center bg-[#f15d4c] font-bold uppercase leading-tight text-white',
        variant === 'fixed'
          ? 'min-h-[48px] flex-1 px-1 py-2.5 text-[14px]'
          : 'min-h-[50px] flex-[1.1] px-4 py-3 text-[15px]'
      )}
    >
      Buy Now
    </button>
  );

  const gmsButton = (
    <button
      type="button"
      onClick={() => handleOpenGmsSheet(gmsMonthlyAmount)}
      className={cn(
        'flex items-center justify-center border border-[#f15d4c] bg-white font-bold uppercase leading-tight text-[#f15d4c]',
        variant === 'fixed'
          ? 'min-h-[48px] flex-1 px-1 py-2.5 text-[14px]'
          : 'min-h-[50px] flex-1 px-4 py-3 text-[15px]'
      )}
    >
      10+1 Monthly Plan
    </button>
  );

  return (
    <>
      {variant === 'fixed' ? (
        <div className="fixed bottom-0 left-0 right-0 z-30 bg-white px-0.5 py-1 shadow-[0_0_7px_0_rgba(0,0,0,0.19)] md:hidden">
          <div className="flex gap-1 px-0.5">
            {gmsButton}
            {buyNowButton}
          </div>
        </div>
      ) : (
        <div className="hidden gap-2 md:flex">
          {buyNowButton}
          {gmsButton}
        </div>
      )}

      {gmsPrice > 0 && (
        <GoldMinePlanSheet
          open={isGmsSheetOpen}
          discountedPrice={gmsPrice}
          gmsFirstInstallmentDiscountEnabled={gmsFirstInstallmentDiscountEnabled}
          gmsFirstInstallmentDiscountPercentage={gmsFirstInstallmentDiscountPercentage}
          onClose={handleCloseGmsSheet}
          onSubscribeClick={onGmsSubscribeClick}
          onTncClick={onGmsTncClick}
        />
      )}
    </>
  );
}
